import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * Renders description text as markdown. Supports bold, italic, lists, links, etc.
 * Use when displaying stored description content.
 * @param {string} [text] - Description text to render
 * @param {React.ReactNode} [children] - Alternative to text (children take precedence)
 * @param {string} [emptyFallback] - Shown when text is empty (e.g. "—")
 */
export default function DescriptionDisplay({ text: textProp, children, emptyFallback }) {
  const text = String(textProp ?? children ?? '').trim();
  if (!text) return emptyFallback ? <span className="tp-description-empty">{emptyFallback}</span> : null;
  return (
    <div className="tp-description">
      <ReactMarkdown
        components={{
          p: ({ node, ...props }) => <p style={{ margin: '0 0 0.5em 0' }} {...props} />,
          ul: ({ node, ...props }) => <ul style={{ margin: '0.25em 0', paddingLeft: '1.25em' }} {...props} />,
          ol: ({ node, ...props }) => <ol style={{ margin: '0.25em 0', paddingLeft: '1.25em' }} {...props} />,
          a: ({ node, children: linkChildren, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--tp-accent)', textDecoration: 'underline' }}>
              {linkChildren || props.href}
            </a>
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
